<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh;display: flex;margin-top: -70px;"
  >

    <h2 class="text-center">
      <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
      <br />
      Put your phone in landscape mode
    </h2>
  </v-col>
  <v-container v-else class="px-5 col-12">
    <material-card color="teal">
      <template v-slot:header>
        <div class="px-3">
          <h4 class="title font-weight-light mb-0">Pin Panel</h4>
        </div>
        <v-spacer />
      </template>

      <v-container class="col-12 mx-0 mt-2">
        <v-tabs
          background-color="white"
          color="teal"
          v-model="tab"
        >
          <v-tab>Generate</v-tab>
          <v-tab>History</v-tab>
          <v-tab>Payout</v-tab>
        </v-tabs>

        <v-divider />

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item>
            <v-row class="mx-0 mt-5">
              <select-project
                v-model="generate.project"
                :project-list-custom="projectList"
                item-text="name"
                item-value="entity_id"
                hide-details
                class="report-base-filter mr-2"
                style="max-width: 230px; min-width: 180px"
              />
              <v-select
                v-model="generate.type"
                :items="types"
                label="Type"
                hide-details
                class="report-base-filter mx-2"
                style="max-width: 200px; min-width: 135px"
              ></v-select>

              <v-text-field
                v-model="generate.amount"
                label="Amount"
                small
                hide-details
                class="ml-2"
                style="max-width: 150px"
              ></v-text-field>

              <v-select
                v-model="generate.currency"
                :items="currencies"
                label="Currency"
                hide-details=""
                class="mr-2"
                style="z-index: 800; max-width: 75px"
              />

              <v-text-field
                v-model="generate.count"
                label="Pin count"
                small
                hide-details
                class="mx-2"
                style="max-width: 100px"
              ></v-text-field>

              <date-picker
                v-model="generate.expire"
                label="Expire"
                style="max-width: 150px"
              />

              <v-btn color="teal" :dark="!generate.loading" v-on:click="generateCodes()" class="mt-2 ml-2" :disabled="generate.loading" :loading="generate.loading">Generate</v-btn>
              <export :fields="exportFields(generate.headers)" :data="generate.items" v-if="generate.items.length > 0" />
            </v-row>

            <v-data-table
              :headers="generate.headers"
              :items="generate.items"
            />
          </v-tab-item>
          <v-tab-item>
            <v-row class="mx-0 mt-5">
              <select-project
                v-model="list.project"
                :project-list-custom="projectList"
                item-text="name"
                item-value="entity_id"
                class="report-base-filter mr-2"
                style="max-width: 230px;min-width: 200px"
              />

              <v-select
                v-model="list.type"
                :items="types"
                label="Type"
                hide-details
                class="report-base-filter mx-2"
                style="max-width: 150px;min-width: 135px"
              ></v-select>

              <v-select
                v-model="list.status"
                :items="statuses"
                label="Status"
                hide-details
                multiple
                class="report-base-filter mx-2"
                style="max-width: 210px;min-width: 120px"
              ></v-select>

              <date-picker
                v-model="list.start"
                label="Date Start"
                style="max-width: 150px;min-width: 120px"
              />

              <date-picker
                v-model="list.end"
                label="Date End"
                style="max-width: 150px;min-width: 120px"
              />

              <v-btn color="teal" :dark="!list.loading" v-on:click="search()" class="mt-2 ml-2" :disabled="list.loading" :loading="list.loading">Search</v-btn>
              <export :fields="exportFields(list.headers)" :data="list.items" v-if="list.items.length > 0" />
            </v-row>
            <v-data-table
              :headers="list.headers"
              :items="list.items"
            ></v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-row class="mx-0 mt-5">
              <v-text-field
                label="Pin"
                color="teal"
                v-model="payout.code"
                hide-details
                append-outer-icon="search"
                @click:append-outer="searchAccountByCode"
                v-on:keyup.enter="searchAccountByCode"
              />
            </v-row>
            <v-divider class="mt-5 mb-3" />
            <v-row class="ma-0" v-if="payout.account">

              <v-text-field
                :prefix="payout.account.account_id + ':'"
                label="Login"
                v-model="payout.account.login"
                hide-details
                readonly
                class="col-3"
              />

              <v-text-field
                :suffix="payout.account.currency"
                label="Balance"
                v-model="payout.account.balance"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                :suffix="(payout.account.bonus.rollover_init - payout.account.bonus.rollover).toFixed(2) + '/' + payout.account.bonus.rollover_init"
                label="Bonus"
                v-model="payout.account.bonus.amount"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                :suffix="(payout.account.bonus_sport.rollover_init - payout.account.bonus_sport.rollover).toFixed(2) + '/' + payout.account.bonus_sport.rollover_init"
                label="Bonus Sport"
                v-model="payout.account.bonus_sport.amount"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                label="Status"
                :value="payout.statusMap[payout.account.frozen]"
                hide-details
                readonly
                class="col-1"
              />

              <v-text-field
                label="Email"
                v-model="payout.account.email"
                hide-details
                readonly
                class="col-3"
              />

              <v-text-field
                label="Phone"
                v-model="payout.account.phone"
                hide-details
                readonly
                class="col-3"
              />

              <v-checkbox
                v-model="payout.account.data.kyc.psp"
                :value="payout.account.data.kyc.psp"
                label="PSP"
                color="teal"
                hide-details
                true-value="1"
                false-value="0"
                class="ml-2"
                readonly
              />

              <v-checkbox
                v-model="payout.account.data.kyc.id_card"
                :value="payout.account.data.kyc.id_card"
                label="ID Card"
                color="teal"
                hide-details
                true-value="1"
                false-value="0"
                class="ml-2"
                readonly
              />

              <v-checkbox
                v-model="payout.account.data.kyc.bills"
                label="Bills"
                color="teal"
                hide-details
                true-value="1"
                false-value="0"
                class="ml-2"
                readonly
              />

              <v-checkbox
                v-model="payout.account.data.kyc.selfie"
                label="Selfie"
                color="teal"
                hide-details
                true-value="1"
                false-value="0"
                class="ml-2"
                readonly
              />

              <v-btn
                small
                dark
                color="teal"
                class="mt-4 ml-4"
                v-text="(payout.account.data.kyc.verified || 0) != '0' ? 'Verified' : 'Verify'"
              ></v-btn>
            </v-row>
            <v-row class="ma-0" v-if="payout.account">

              <v-text-field
                v-for="(item, index) in payout.account.profile"
                :key="index"
                :label="capitalize(index)"
                :value="item"
                hide-details
                readonly
                class="col-3"
              />

            </v-row>
            <v-row class="mt-3 mb-2 mx-0" v-if="payout.transaction">
              <v-label>Transaction:</v-label>
            </v-row>
            <v-row class="ma-0" v-if="payout.transaction">

              <v-text-field
                label="Transaction ID"
                :value="payout.transaction.account_transaction_id"
                hide-details
                readonly
                class="col-2"
              />
              <v-text-field
                label="Alias"
                :value="payout.transaction.alias"
                hide-details
                readonly
                class="col-3"
              />

              <v-text-field
                label="Amount"
                :value="payout.transaction.amount"
                :suffix="payout.account.currency"
                hide-details
                readonly
                class="col-2"
              />


              <v-text-field
                label="Status"
                :value="payout.transaction.status"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                label="Type"
                :value="payout.transaction.type"
                hide-details
                readonly
                class="col-2"
              />


              <v-text-field
                label="Paymethod"
                :value="payout.transaction.paymethod"
                hide-details
                readonly
                class="col-1"
              />

              <v-text-field
                label="Created"
                :value="payout.transaction.created"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                label="Completed"
                :value="payout.transaction.completed"
                hide-details
                readonly
                class="col-2"
              />

              <v-text-field
                label="Comment"
                :value="payout.transaction.comment"
                hide-details
                readonly
                class="col-6"
              />

              <v-spacer />

              <v-btn
                v-if="payout.transaction.type == 'withdraw' && payout.transaction.status == 'pending'"
                small
                dark
                color="teal"
                class="mt-4 ml-4"
                @click="payoutHandler()"
              >Payout
              </v-btn>

            </v-row>
          </v-tab-item>
        </v-tabs-items>


      </v-container>
    </material-card>
  </v-container>
</template>

<style>

</style>

<script>
  import { API } from '@/utils/api'
  import moment from 'moment'
  import { map, capitalize } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      tab: null,

      currencies: [],
      payout: {
        statusMap: {
          0: 'Open',
          1: 'Closed',
          2: 'Frozen',
        },
        code: '',
        account: false,
        transaction: false,
        loading: false,
      },
      list: {
        project: null,
        loading: false,
        type: 'deposit',
        status: [ 'new' ],
        start: moment().utc().format('YYYY-MM-DD'),
        end: moment().utc().format('YYYY-MM-DD'),
        items: [],
        headers: [
          { text: 'PinID', value: 'pin_id', sortable: true },
          { text: 'Project', value: 'project', sortable: true },
          { text: 'Alias', value: 'transaction_ref', sortable: true },
          { text: 'Pin', value: 'code', sortable: true },
          { text: 'Amount', value: 'amount', sortable: true },
          { text: 'Currency', value: 'currency', sortable: true },
          { text: 'Status', value: 'status', sortable: true },
          { text: 'Type', value: 'type', sortable: true },
          { text: 'Created', value: 'created', sortable: true },
          { text: 'Expire', value: 'expire', sortable: true },
        ]
      },
      generate: {
        project: null,
        loading: false,
        type: 'deposit',
        status: 'new',
        amount: 0,
        currency: 'TND',
        count: 1,
        expire: moment().add(1, 'year').format('YYYY-MM-DD'),
        items: [],
        headers: [
          { text: 'PinID', value: 'pin_id', sortable: true },
          { text: 'Project', value: 'project', sortable: true },
          { text: 'Pin', value: 'code', sortable: true },
          { text: 'Amount', value: 'amount', sortable: true },
          { text: 'Currency', value: 'currency', sortable: true },
          { text: 'Status', value: 'status', sortable: true },
          { text: 'Type', value: 'type', sortable: true },
          { text: 'Created', value: 'created', sortable: true },
          { text: 'Expire', value: 'expire', sortable: true },
        ]
      },
      loading: false,
      types: [ 'deposit', 'withdraw' ],
      statuses: [ 'new', 'expired', 'used', 'error' ],
      projectList: []
    }),

    mounted () {
      this.loadProjects().then(r => {
        this.generate.project = this.projectList[0]
        this.list.project = this.projectList[0]
      })
      this.loadCurrencies().then(r => {
        this.generate.currency = this.currencies[0]
      })
    },

    computed: {},

    watch: {},

    methods: {
      capitalize (str) {
        return capitalize(str)
      },

      exportFields (headers) {
        return map(headers, 'value')
      },

      loadProjects () {
        return API.call('/kiosk/project_list.json', {}).then(r => {
          this.projectList = r.data
        })
      },

      loadCurrencies () {
        this.loading = true

        return API.call('/kiosk/entities/get_base.json', {}).then(resp => {
          this.currencies = resp.data && resp.data.wallet ? map(resp.data.wallet, (o) => o.currency) : this.$store.state.auth.currencies
          return resp.data
        }).catch(e => {
        }).finally(r => {
          this.loading = false
        })
      },

      payoutHandler: function () {
        this.payout.loading = true
        API.call('/$v/payment_handler/payout.json', {
          account_transaction_id: this.payout.transaction.account_transaction_id,
          code: this.payout.transaction.account
        }).then(resp => {

          this.$notification.show = true
          this.$notification.message = map(resp.data.messages, 'description').join('<br />')
          this.$notification.type = resp.data.status == 'success' ? resp.data.status : 'error'

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.searchAccountByCode()
          this.payout.loading = false
        })

      },

      searchAccountByCode () {
        return API.call('/kiosk/pin/account_by_code.json', {
          code: this.payout.code
        }).then(r => {
          this.payout.account = r.data.account
          this.payout.transaction = r.data.transaction
        })
      },

      generateCodes () {
        this.generate.loading = true
        if (!this.generate.project) return

        API.call('/kiosk/pin/generate.json', {
          count: this.generate.count,
          amount: this.generate.amount,
          currency: this.generate.currency,
          type: this.generate.type,
          expire: this.generate.expire,
          project: this.generate.project.name,
        }, null, { entity_id: this.generate.project.entity_id }).then(resp => {
          this.generate.items = resp.data
          return resp.data
        }).then(r => {
          this.$notification.show = true
          this.$notification.message = 'Pin Codes generated'
          this.$notification.type = 'success'
        }).catch(e => {
        }).finally(r => {
          this.generate.loading = false
        })
      },

      search () {
        this.list.loading = true
        if (!this.list.project) return

        API.call('/kiosk/pin/list.json', {
          status: this.list.status,
          type: this.list.type,
          start: this.list.start,
          end: this.list.end,
          project: this.list.project.name,
        }, null, { entity_id: this.list.project.entity_id }).then(resp => {
          this.list.items = resp.data
          return resp.data
        }).catch(e => {
        }).finally(r => {
          this.list.loading = false
        })
      }
    }

  }
</script>
